export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="col-span-1 sm:col-span-2 md:col-span-2">
            <div className="flex items-center space-x-2 mb-3 sm:mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-sky-500 to-emerald-400 rounded-md flex items-center justify-center">
                <i className="ri-cloud-line text-white text-lg"></i>
              </div>
              <span className="text-lg sm:text-xl font-bold">壹码云</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md text-sm sm:text-base">
              专注于 ARM 架构云计算技术，为企业提供高性能、高可靠性的云服务解决方案
            </p>
            <div className="flex space-x-4">
              <i className="ri-wechat-fill text-xl sm:text-2xl text-gray-400 hover:text-white cursor-pointer"></i>
              <i className="ri-weibo-fill text-xl sm:text-2xl text-gray-400 hover:text-white cursor-pointer"></i>
              <i className="ri-mail-fill text-xl sm:text-2xl text-gray-400 hover:text-white cursor-pointer"></i>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">产品服务</h3>
            <ul className="space-y-2 text-gray-400 text-sm sm:text-base">
              <li className="hover:text-white cursor-pointer">ARM 云服务器</li>
              <li className="hover:text-white cursor-pointer">云数据库</li>
              <li className="hover:text-white cursor-pointer">云存储</li>
              <li className="hover:text-white cursor-pointer">负载均衡</li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">支持与服务</h3>
            <ul className="space-y-2 text-gray-400 text-sm sm:text-base">
              <li className="hover:text-white cursor-pointer">技术文档</li>
              <li className="hover:text-white cursor-pointer">API 文档</li>
              <li className="hover:text-white cursor-pointer">在线客服</li>
              <li className="hover:text-white cursor-pointer">工单系统</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-500 text-xs sm:text-sm text-center sm:text-left">
            © 2024 壹码云（上海）科技有限公司. 保留所有权利
          </p>
          <div className="flex space-x-4 sm:space-x-6 text-xs sm:text-sm text-gray-500 mt-3 sm:mt-0">
            <span className="hover:text-white cursor-pointer">隐私政策</span>
            <span className="hover:text-white cursor-pointer">服务条款</span>
            <span className="hover:text-white cursor-pointer">ICP 备案号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
